// SPDX-License-Identifier: AGPL-3.0-or-later

import {ViewProfileIcon} from '@app/features/ui/action_menu/ContextMenuIcons';
import {MenuItem} from '@app/features/ui/action_menu/MenuItem';
import * as UserProfileCommands from '@app/features/user/commands/UserProfileCommands';
import type {User} from '@app/features/user/models/User';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

interface UserProfileMenuItemProps {
	user: User;
	guildId?: string;
	onClose: () => void;
}
export const UserProfileMenuItem: React.FC<UserProfileMenuItemProps> = observer(({user, guildId, onClose}) => {
	const {t} = useLingui();
	const handleViewProfile = useCallback(() => {
		onClose();
		UserProfileCommands.openUserProfile(user.id, guildId);
	}, [onClose, user.id, guildId]);
	return (
		<MenuItem icon={<ViewProfileIcon size={16} />} onClick={handleViewProfile}>
			{t`View Profile`}
		</MenuItem>
	);
});
